import React from 'react';
import { LocationLiteDomainContext } from './context.esm.js';

/**
 * Simple hook to retrieve the cookie domain value from our context
 */
var useLocationLiteDomain = function () {
    var cookieDomain = React.useContext(LocationLiteDomainContext);
    return cookieDomain;
};

export { useLocationLiteDomain };
//# sourceMappingURL=hooks.esm.js.map
